import { SyntheticEvent } from 'react'
import { useLocation, useNavigate } from 'react-router'

import { Tab, Tabs } from '@mui/material'

import {
  ActivityCustomers,
  ActivityLeads,
  ActivityVisitors,
  ConversionReccuring,
  ConversionRefund,
  SettingBilling,
} from 'assets/icons'

const RoutingTabs = () => {
  const navigate = useNavigate()
  const location = useLocation()

  const handleChange = (event: SyntheticEvent, newValue: string) => {
    // Preserve URL parameters when navigating between conversion tabs
    if (location.pathname.includes('/conversions/') && newValue.includes('/conversions/')) {
      const searchParams = location.search
      navigate(newValue + searchParams, { replace: true })
    } else {
      navigate(newValue, { replace: true })
    }
  }

  const activity: TabProps[] = [
    {
      name: 'Visitors',
      link: '/activity/visitor',
      icon: <ActivityVisitors color="secondary.dark" />,
    },
    {
      name: 'Leads',
      link: '/activity/lead',
      icon: <ActivityLeads color="secondary.dark" />,
    },
    {
      name: 'Customers',
      link: '/activity/customer',
      icon: <ActivityCustomers color="secondary.dark" />,
    },
  ]

  const conversions: TabProps[] = [
    {
      name: 'Forms',
      link: '/conversions/forms',
      icon: <ActivityLeads color="secondary.dark" />,
    },
    {
      name: 'Leads',
      link: '/conversions/leads',
      icon: <ActivityLeads color="secondary.dark" />,
    },
    {
      name: 'Orders',
      link: '/conversions/orders',
      icon: <SettingBilling color="secondary.dark" />,
    },
    {
      name: 'Refunds',
      link: '/conversions/refunds',
      icon: <ConversionRefund color="secondary.dark" />,
    },
    {
      name: 'Recurring',
      link: '/conversions/recurring',
      icon: <ConversionReccuring color="secondary.dark" />,
    },
  ]

  const pathArr = location.pathname.split('/') || []

  const currentTabs = () => {
    switch (pathArr[1]) {
      case 'tags':
        return []
      case 'settings':
        return []
      case 'developer':
        return []
      case 'activity':
        return activity
      case 'conversions':
        return conversions
      case 'setup':
      case 'facebook_ads':
      case 'shopify':
      case 'paypal':
      case 'thrivecart':
      case 'clickfunnels':
      case 'kajabi':
      case 'gohighlevel':
      case 'leadconnector':
      case 'woocommerce':
      case 'google_ads':
      case 'bing':
      case 'stripe':
      case 'bigcommerce':
      case 'tiktok_ads':
        return []
      case 'reports':
        return []
      default:
        return []
    }
  }

  const value = () => {
    switch (pathArr[1]) {
      case 'reports':
        if (pathArr[3] === 'ads') return '/reports/traffic/ads'
        if (pathArr[3] === 'organic') return '/reports/traffic/organic'
        if (pathArr[3] === 'pages') return '/reports/traffic/pages'
        return location.pathname
      default:
        return location.pathname
    }
  }

  const tabs = currentTabs()

  if (!tabs.length) {
    return null
  }

  return (
    <Tabs
      value={value()}
      sx={{ alignSelf: 'end', mt: 1.5 }}
      indicatorColor="secondary"
      onChange={handleChange}>
      {tabs.map(tag => (
        <Tab
          key={tag.name.toLowerCase()}
          value={tag.link}
          label={tag.name}
          icon={tag.icon}
          iconPosition="start"
        />
      ))}
    </Tabs>
  )
}

interface TabProps {
  name: string
  link: string
  icon: JSX.Element
}

export default RoutingTabs
